document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 767) {
    const newsletter = document.querySelector('.footer__newsletter');
    const gridContainer = document.querySelector('.footer .float-grid.grid--uniform');

    if (newsletter && gridContainer) {
      // Create wrapper with the necessary classes
      const wrapper = document.createElement('div');
      wrapper.classList.add('grid__item', 'medium-up--one-third', 'footer__block');

      // Move the newsletter into the wrapper
      newsletter.parentNode.removeChild(newsletter); // detach from original location
      wrapper.appendChild(newsletter);

      // Insert wrapper as the second child
      const secondChild = gridContainer.children[1];
      if (secondChild) {
        gridContainer.insertBefore(wrapper, secondChild);
      } else {
        gridContainer.appendChild(wrapper);
        
      }
    }
  }
});

  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".video-autoplay-wrapper");
    if (!wrapper) return;

    const video = wrapper.querySelector("video");
    const toggle = wrapper.querySelector(".video-sound-toggle");

    if (!video || !toggle) return;

    toggle.addEventListener("click", function () {
      video.muted = !video.muted;

      if (!video.muted) {
        video.volume = 1;
        toggle.classList.remove("muted");
        toggle.classList.add("unmuted");
      } else {
        video.volume = 0;
        toggle.classList.add("muted");
        toggle.classList.remove("unmuted");
      }

      video.play().catch((e) => console.warn("Play failed:", e));
    });
  });